export default function EntranceSteps({children}){
    
    return(
        <div className="entrance-steps">
            {children}
        </div>
    )

}